import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function NotFoundPage() {
  useEffect(() => {
    document.title = 'LOST IN THE TOONVERSE — ARC TOONS';
  }, []);

  return (
    <div
      data-testid="notfound-page"
      className="relative flex min-h-screen flex-col items-center justify-center px-6 pb-24 pt-32 text-center"
    >
      <div
        aria-hidden="true"
        className="absolute inset-0"
        style={{ background: 'radial-gradient(50% 45% at 50% 50%, rgba(22,119,255,0.14) 0%, transparent 70%)' }}
      />
      <motion.span
        aria-hidden="true"
        className="text-stroke relative font-display text-[30vw] font-extrabold leading-none sm:text-[12rem]"
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      >
        404
      </motion.span>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2, ease: 'easeOut' }}
        className="relative"
      >
        <h1 className="mt-4 font-display text-2xl font-extrabold uppercase tracking-tight sm:text-3xl">
          LOST IN THE <span className="text-electric text-glow-blue">TOONVERSE</span>
        </h1>
        <p className="mt-4 text-sm text-snow/60">
          This district does not exist yet. The Toons are still drawing the map.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-button"
          className="light-sweep mt-9 inline-block rounded-full bg-gradient-to-r from-arc via-electric to-arc px-8 py-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-white shadow-[0_0_32px_rgba(0,200,255,0.45)] transition-transform duration-200 hover:scale-[1.04]"
        >
          BACK TO THE TOONVERSE
        </Link>
      </motion.div>
    </div>
  );
}
